import {
  useContext,
  createContext,
} from "react"

export interface SliderContextValue {
  inputValues: number[];
  addInput: (id: string, value: number) => void;
  removeInput: (id: string) => void;
  setSliderDisabled: (disabled: boolean) => void;
}

type ContextType = SliderContextValue | null

export const SliderContext = createContext<ContextType>(null)

export function useSliderContext() {
  const context = useContext(SliderContext)

  if (context == null) {
    throw new Error("Slider components must be wrapped in <Slider />")
  }

  return context
}
